<div *transloco="let t" class="flex flex-col gap-4">
  <p>{{ t('Entrez les adresses email des utilisateurs que vous souhaitez inviter.') }}</p>

  <pxc-emails-input [(emails)]="userMails" />

  <div class="flex justify-between gap-2">
    <button appearance="outline" data-testid="cancel" tuiButton type="button" (click)="close()">
      {{ t('Annuler') }}
    </button>
    <button data-testid="confirm" tuiButton type="button" [disabled]="userMails.length === 0" (click)="addUser()">
      {{ t('Ajouter') }}
    </button>
  </div>
</div>
